<template>
  <tr>
    <td class="font-weight-600 w-25" :class="{ 'border-0':noBorder}">
     <span v-if="label"> {{ label }} </span>
     <i v-if="icon" class="lni text-primary" :class="icon"></i>
    </td>
    <td class="nl2br" :class="{ 'border-0':noBorder}"><slot></slot></td>
    <td width="15" v-if="copyText" :class="{ 'border-0':noBorder}">
      <copy-text :text="copyText"></copy-text>
    </td>
    <td width="0" v-if="!copyText" :class="{ 'border-0':noBorder}">
     
    </td>
  </tr>
</template>

<script>
import CopyText from '@/components/common/CopyText'

export default {
  components:{
    CopyText
  },

  props: ["label", "noBorder","icon", "copyText"],
};
</script>


